import { createFileRoute, Outlet, useParams } from "@tanstack/react-router";
import { RecordWorkspaceAssetsTable } from "@/features/records/components";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId/workspace/assets/$assetId/workspace/records/$recordId/workspace/assets",
)({
	component: RecordWorkspaceAssetsTab,
	validateSearch: (search: Record<string, unknown>) => ({
		q: typeof search.q === "string" ? search.q : undefined,
	}),
});

/**
 * Ticket → asset → record workspace Assets tab — view-only association list.
 * Row open nests an asset drawer under this tab; Workspace jumps to the
 * ticket-scoped asset workspace.
 */
function RecordWorkspaceAssetsTab() {
	const params = useParams({
		from: "/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId/workspace/assets/$assetId/workspace/records/$recordId/workspace/assets",
	});

	return (
		<div className="relative flex min-h-0 w-full flex-1 flex-col">
			<RecordWorkspaceAssetsTable
				orgId={params.orgId}
				recordId={params.recordId}
				ticketId={params.ticketId}
				hostAssetId={params.assetId}
				assetNavTarget="ticketScoped"
				syncSearchToUrl={false}
			/>
			<Outlet />
		</div>
	);
}
